import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircleIcon, ActivityIcon, FlameIcon } from 'lucide-react';
export function SolutionSection() {
  const failures = [{
    icon: <ActivityIcon className="w-6 h-6 text-[#B8963E]" data-id="element-148" />,
    text: 'El cardio intenso a esta edad dispara el cortisol, la hormona que ordena a tu cuerpo acumular grasa abdominal.'
  }, {
    icon: <AlertCircleIcon className="w-6 h-6 text-[#B8963E]" data-id="element-149" />,
    text: 'Las ensaladas crudas por la noche fermentan en tu intestino porque tu capacidad enzimática ha disminuido.'
  }, {
    icon: <FlameIcon className="w-6 h-6 text-[#B8963E]" data-id="element-150" />,
    text: 'El déficit calórico extremo estresa a tu tiroides, ralentizando tu metabolismo aún más.'
  }];
  return <section className="py-20 bg-[#FAF7F2]" data-id="element-151">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-152">
        <FadeIn data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2A26] text-center mb-12" data-id="element-154">
            Por qué lo que has intentado hasta ahora ha fallado:
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-155">
          {failures.map((item, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-156">
              <div className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#E8EDE6]" data-id="element-157">
                <div className="flex-shrink-0 mt-1 p-2 bg-[#FAF7F2] rounded-full" data-id="element-158">
                  {item.icon}
                </div>
                <p className="text-lg text-[#6B6560] leading-relaxed" data-id="element-159">
                  {item.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}